import React, { memo } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import bemit from 'Functions/bemit';
export default memo(function BookingFormWrapper({
  ...props
}) {
  const continue_as_guest = BookingFormStore.useState(s => s.continue_as_guest);
  const create_account = BookingFormStore.useState(s => s.create_account);
  const oauth_register = BookingFormStore.useState(s => s.oauth_register);
  const logged_in = BookingFormStore.useState(s => s.logged_in);
  const has_fields = continue_as_guest || create_account || logged_in;
  const modifiers = has_fields ? ['with-form'] : [];
  if (oauth_register) modifiers.push('oauth-register');
  return /*#__PURE__*/React.createElement("div", {
    className: bemit('c-booking-auth', modifiers)
  }, props.children);
});
